import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, List, IconButton, ModalFooter } from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';
import { getLocalizedValue } from '../../helpers/localizationUtils';

function ReorderFavoritesModal({ open, onClose, favorites, onReorder }) {
  const [orderedFavorites, setOrderedFavorites] = useState([...favorites]);

  const moveUp = (index) => {
    if (index === 0) return;
    const newOrder = [...orderedFavorites];
    [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
    setOrderedFavorites(newOrder);
  };

  const moveDown = (index) => {
    if (index === orderedFavorites.length - 1) return;
    const newOrder = [...orderedFavorites];
    [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    setOrderedFavorites(newOrder);
  };

  const handleSave = () => {
    onReorder(orderedFavorites.map(fav => fav.favoriteId));
    onClose();
  };

  const footer = (
    <ModalFooter>
      <Button buttonStyle="primary" onClick={handleSave} marginBottom0>
        <FormattedMessage id="ui-reports.button.save" />
      </Button>
      <Button onClick={onClose} marginBottom0>
        <FormattedMessage id="ui-reports.button.cancel" />
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      open={open}
      label={<FormattedMessage id="ui-reports.favorites.reorder" defaultMessage="Reorder Favorites" />}
      footer={footer}
      onClose={onClose}
    >
      <List
        items={orderedFavorites}
        itemFormatter={(item, index) => (
          <div style={{ display: 'flex', alignItems: 'center', padding: '0.5rem', borderBottom: '1px solid #ddd' }}>
            <div style={{ flex: 1 }}>
              <strong>{getLocalizedValue(item.name)}</strong>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <IconButton
                icon="arrow-up"
                onClick={() => moveUp(index)}
                disabled={index === 0}
                ariaLabel="Move up"
              />
              <IconButton
                icon="arrow-down"
                onClick={() => moveDown(index)}
                disabled={index === orderedFavorites.length - 1}
                ariaLabel="Move down"
              />
            </div>
          </div>
        )}
      />
    </Modal>
  );
}

ReorderFavoritesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  favorites: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReorder: PropTypes.func.isRequired
};

export default ReorderFavoritesModal;
